import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { trackByRef } from 'src/app/lego-utils';
import { filter, Subscription } from 'rxjs';
import { EquipmentLookupService } from 'src/app/state/equipment/equipment-lookup.service';

@Component({
  selector: 'em-equipment-select',
  styleUrls: ['./equipment-select.component.less'],
  templateUrl: './equipment-select.component.html',
  standalone: false,
})
export class EquipmentSelectComponent implements OnInit, OnDestroy {
  public readonly trackByRef = trackByRef;
  public control = new FormControl();

  public equipments$ = this.equipmentLookup.equipmentList$;
  public selectedEquipmentId$ = this.equipmentLookup.selectedEquipmentId$;
  public loading$ = this.equipmentLookup.loading$;

  private readonly subscriptions = new Subscription();

  public constructor(
    private readonly equipmentLookup: EquipmentLookupService,
    private readonly router: ActivatedRoute
  ) {}

  public ngOnInit(): void {
    this.subscriptions.add(
      this.control.valueChanges.pipe(filter((id) => !!id)).subscribe((equipmentId: string) => {
        this.equipmentLookup.setSelectedEquipment(equipmentId);
      })
    );

    this.subscriptions.add(
      this.selectedEquipmentId$.subscribe((selectedId: string | undefined) => {
        this.control.setValue(selectedId, { emitEvent: false });
      })
    );

    this.subscriptions.add(
      this.router.queryParamMap.subscribe((queryParams) => {
        const equipmentNumber = queryParams.get('equipmentNumber');

        if (equipmentNumber) {
          this.equipmentLookup.setSelectedEquipment(equipmentNumber);
        }
      })
    );
  }

  public ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
